/* Adds/removes .hover-active on product cards (li.productgrid--item.imagestyle--medium).
   Delegated and loaded once per page so cards (incl. dynamically inserted ones) need no per-card <script>. */
(function () {
  if (window.__shProductCardHover) return;
  window.__shProductCardHover = true;
  var CARD = 'li.productgrid--item.imagestyle--medium';

  // Capture phase: mouseenter does not bubble.
  document.addEventListener(
    'mouseenter',
    function (event) {
      var t = event.target;
      if (!t || !t.matches || !t.matches('.productitem--image-link')) return;
      var card = t.closest(CARD);
      if (card) card.classList.add('hover-active');
    },
    true
  );

  document.addEventListener(
    'mouseleave',
    function (event) {
      var t = event.target;
      if (!t || !t.matches || !t.matches(CARD)) return;
      t.classList.remove('hover-active');
    },
    true
  );
})();
